import TapToOpen from './TapToOpen.react';

import Config from '../../utils/Config';

class ProjectLogo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loaded  : false,
            uuid    : uuid()
        };

        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        var self = this;

        $('.project').on('scroll', this.onScroll);
        $(window).resize(this.onScroll);
        $(window).resize(this.adjustTitleSize);


        var img = new window.Image();

        img.onload = function() {
            var width   = this.width;
            var height  = this.height;

            self.setState({ loaded : true }, function() {

                $('#pre-loader').animate({ opacity : 0 }, 1000);

                setTimeout(() => {
                    $('#pre-loader').css({ display : 'none' });
                }, 1000);

                $('.bgimg').css({ 'background-image' : 'url('+Config.imgUrl()+'public/codi-studios/projects/'+this.props.project.id+'/header.jpg)' });
                $('.project').css({ opacity : 1 });

                var title_height = 110;
                // console.log('height', ($('.project-header__subtitle').height() + title_height))

                // if ($('.project-header__subtitle').height() + title_height > 300) {
                //     $('.project-header__bar').css({
                //         'height' : ($('.project-header__subtitle').height() + title_height + 30)
                //     });
                if ($('#ul-'+self.state.uuid).height() + title_height > 300) {
                    $('.project-header__bar').css({
                        'min-height' : ($('#ul-'+self.state.uuid).height() + title_height)
                    });
                }

                var bar_height = $('#ul-'+self.state.uuid).height() + 30;
                if (bar_height > 220) {
                    $('.project-header__services').css({ 'height' : bar_height });
                }
                $('.project').scrollTop(0)

                this.adjustTitleSize();
            });
        }

        img.onerror = function() {
            console.error('image missing :: '+src)
        }

        img.src = Config.imgUrl()+'/public/codi-studios/projects/'+this.props.project.id+'/header.jpg';

    }

    componentWillUnmount() {
        $('.project').off('scroll', this.onScroll);
        $(window).off('resize', this.onScroll);
        $(window).off('resize', this.adjustTitleSize);
    }

    adjustTitleSize() {
        console.log('span', $('.project-header__title span').width())
        console.log('div', $('.project-header__title').width())

        while ($('.project-header__title span').width() > $('.project-header__title').width()) {
            var fontSize = $(".project-header__title").css("fontSize");
            fontSize  = parseInt(fontSize);
            $('.project-header__title').css({
                'font-size' : fontSize - 1
            })
        }
    }

    onScroll() {
        var scrollTop = $('.project').scrollTop();

        if (scrollTop < 0)
            scrollTop = 0;

        var proc = scrollTop / 10;
        $('.bgimg').css({ 'transform' : 'translate3d(0px, '+scrollTop+'px, 0px)' });
        $('.slotholder').css({ 'transform' : 'translate3d(0px, '+(-1*(scrollTop/2))+'px, 0px)' });
    }

    render() {
        var project = this.props.project;
        var uuid    = this.state.uuid;

        if (!this.state.loaded)
            return null;

        return (
            <div className='project-header'>

                { project.url &&
                    <TapToOpen
                        project={project} />
                }

                <div
                    className='project-header__desktop'>

                    { project.header_video ?
                        <div className='parallax-home'>
                            <div className='slotholder'>
                                <video id='video' autoPlay loop muted>
                                    <source src={'/public/codi-studios/projects/'+project.id+'/'+project.header_video} type='video/mp4'></source>
                                </video>
                            </div>
                        </div>
                    :
                        <div className='parallax-home'>
                            <div className='slotholder'>
                                <div className='bgimg'>

                                </div>
                            </div>
                        </div>
                    }

                    <div className='project-header__bar'>
                        <div className='project-header__bar--wrapper'>

                            <div className='project-header__bar--left'>
                                <div className='project-header__title'><span>{project.title}</span></div>
                                <div className='project-header__subtitle'>{project.subtitle}</div>
                            </div>

                            <div className='project-header__bar--right'>
                                <div  className='project-header__services'>
                                    <span>Services.</span>

                                    <ul id={'ul-'+this.state.uuid}>
                                        { project.services.map(function(service, i) {
                                            return (

                                                <li key={'project_service_'+i+service}>

                                                    <div className='project-header__services--nr'>
                                                        { (i<10 ? '0'+(i+1) : (i+1)) }.
                                                    </div>

                                                    {service}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className='project-header__handheld'>

                    <div className='parallax-home'>
                        <div className='slotholder'>
                            <div className='bgimg'>

                            </div>
                        </div>
                    </div>

                    <div className='project-header__handheld--bar'>
                        <div className='project-header__handheld--title'>
                            {project.title}
                        </div>
                        <div className='project-header__handheld--subtitle'>
                            {project.subtitle}
                        </div>

                        <div className='project-header__handheld--hr' />

                        <div className='project-header__handheld--services'>
                            SERVICES.
                        </div>

                        <ul>
                            { project.services.map(function(service, i) {
                                return (

                                    <li key={'project_service_handheld'+i+service}>

                                        <div className='project-header__handheld--nr'>
                                            { (i<10 ? '0'+(i+1) : (i+1)) }.
                                        </div>

                                        {service}
                                    </li>
                                );
                            })}
                        </ul>

                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectLogo;




// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectHeader.react.jsx